import { useEffect } from 'react';

import { useVehicleStores } from '../stores/useVehicleStores';
import { useAuthStore } from '../../../../auth/shared/store/useAuthStore';

export const useLoadMyVehicles = () => {
	const { isAuthenticated } = useAuthStore();

	const { getVehicleStore } = useVehicleStores();

	useEffect(() => {
		if (!isAuthenticated) {
			return undefined;
		}
		getVehicleStore.load();
		return () => {
			getVehicleStore.reset();
		};
	}, [isAuthenticated]);
};
